import type { GetProductByIdQuery, GetProductsByStatusQuery } from '@/shared/hooks/queries/generated';
import { ProductItemData } from '@/shared/types/product';

// Types dérivés des queries
type ProductByIdItem = GetProductByIdQuery['getProductById'];
type ProductFeedItem = GetProductsByStatusQuery['getProductsByStatus'][0];

// Type union pour tous les types de produit
type AnyProductItem = NonNullable<ProductByIdItem> | ProductFeedItem;

export const mapProductToItemData = (product: AnyProductItem): ProductItemData => {
  return {
    id: product.id,
    url: product.url,
    title: product.title,
    price: product.price ?? 0,
    status: product.status,
    itemCondition: product.itemCondition ?? null,
    favouriteCount: product.favouriteCount ?? 0,
    brand: product.brand ?? null,

    // Vendeur
    sellerName: product.sellerName ?? null,
    sellerReviews: product.sellerReviews ?? null,
    sellerRating: product.sellerRating ?? null,

    // Dates
    uploadedAt: product.uploadedAt ?? product.createdAt,
    soldAt: product.status === 'sold' && product.inactivatedAt ? new Date(product.inactivatedAt).toISOString() : null,

    // Images
    images: (product.images ?? []).sort((a, b) => a.displayOrder - b.displayOrder).map((img) => img.url),

    // Attributs dynamiques depuis les données GraphQL (en filtrant les attributs techniques)
    attributes: [
      ...(product.brand
        ? [
            {
              name: 'Marque',
              value: product.brand,
            },
          ]
        : []),
      ...(product.attributes
        ?.filter((attr) => attr.key !== 'brand' && attr.key !== 'uploaded' && attr.key !== 'interested')
        ?.map((attr) => ({
          name: attr.name,
          value: attr.value,
        })) ?? []),
    ],
  };
};

export const mapProductsToItemData = (products: ProductFeedItem[]): ProductItemData[] => {
  return products.map(mapProductToItemData);
};
